import { themeAtom } from "../atoms";
import { useAtomValue } from "jotai";
import { FC } from "react";
import { twMerge } from "tailwind-merge";

const extractInitials = (name: string) => {
  const initials = name
    .split(" ")
    .map((word) => word.charAt(0))
    .join("");
  return initials.toLocaleUpperCase();
};

interface Props {
  name: string;
  avatarClasses?: string;
  textClasses?: string;
}

const Avatar: FC<Props> = ({ name, avatarClasses, textClasses }) => {
  const theme = useAtomValue(themeAtom);

  return (
    <div className="flex items-center gap-1">
      <div
        data-test="avatar"
        className={twMerge(
          "flex h-[28px] w-[28px] items-center justify-center rounded-full border",
          theme.uwhcAssistant.text,
          theme.uwhcAssistant.chatBg,
          avatarClasses,
          theme.uwhcAssistant.border,
        )}
      >
        <p className={twMerge("text-[12px] font-bold", theme.headerComponent.logInCircle.text)}>
          {extractInitials(name)}
        </p>
      </div>
      <span className={twMerge("text-xs font-normal", textClasses)}>{name}</span>
    </div>
  );
};

export default Avatar;
